import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TApplication, TApplicationPayloadUpdate, TApplicationResponse, adaptApplicationFromResponse, adaptApplicationToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_APPLICATION } from '../../backend-paths';


export const applicationUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_APPLICATION}/:id`,
	(payload: TApplicationPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_APPLICATION}/${id}`;

		const dataRequest = adaptApplicationToRequest(data);

		return HttpService.put<TApplicationResponse>(path, dataRequest).then(result => {
			return adaptApplicationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplication> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationUpdateSlice = createSlice({
	name: 'applicationUpdateSlice',
	initialState,
	reducers: {
		clearApplicationUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[applicationUpdateApi.fulfilled.type]: (state, action: PayloadAction<TApplication>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useApplicationUpdateSelector = () => useAppSelector(state => state[applicationUpdateSlice.name]);

export const { clearApplicationUpdate } = applicationUpdateSlice.actions;
